"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var schemaTypes_1 = require("../../../shared/types/schemaTypes");
var getDefaultFormat_1 = require("../../../defaults/getDefaultFormat");
var formatDate_1 = __importDefault(require("../../../shared/util/formatDate"));
var getValueForColumn = function (schema, data, columnLabels) {
    var _a, _b;
    var columnName = schema.name;
    var inputString = '';
    if (schema.outgoingReference &&
        schema.outgoingReference.targetEntity &&
        data.entityReferencePreviews[schema.outgoingReference.targetEntity] &&
        data.entityReferencePreviews[schema.outgoingReference.targetEntity][data.data[columnName]]) {
        inputString = data.entityReferencePreviews[schema.outgoingReference.targetEntity][data.data[columnName]];
    }
    else {
        if (schema.columnType === schemaTypes_1.ColumnType.DateTime || schema.columnType === schemaTypes_1.ColumnType.Date || schema.columnType === schemaTypes_1.ColumnType.Time) {
            var format = getDefaultFormat_1.Format.date;
            switch (schema.columnType) {
                case schemaTypes_1.ColumnType.DateTime:
                    format = getDefaultFormat_1.Format.dateTime;
                    break;
                case schemaTypes_1.ColumnType.Time:
                    format = getDefaultFormat_1.Format.time;
                    break;
            }
            inputString = data.data[columnName] ? formatDate_1.default(data.data[columnName], format) : '';
        }
        else {
            if (columnLabels && schema.columnType === schemaTypes_1.ColumnType.Enum) {
                var key = data.data[columnName];
                inputString = (columnLabels && columnLabels[columnName] && columnLabels[columnName].options && ((_a = columnLabels[columnName]) === null || _a === void 0 ? void 0 : _a.options[key]))
                    ? (_b = columnLabels[columnName]) === null || _b === void 0 ? void 0 : _b.options[key].title : key;
            }
            else {
                inputString = data.data[columnName] || '';
            }
        }
    }
    return inputString;
};
exports.default = getValueForColumn;
